import { Component } from '@angular/core';

/** Fixed decorative layers — ember glow, washi grain, vertical kanji rail. */
@Component({
  selector: 'app-atmosphere',
  standalone: true,
  host: {
    class: 'atmosphere-root',
  },
  template: `
    <div class="atmosphere-layer" aria-hidden="true"></div>
    <div class="washi-grain" aria-hidden="true"></div>
    <div class="kanji-rail" aria-hidden="true">
      改<span class="dot">・</span>善<span class="dot">・</span>続<span
        class="dot"
        >・</span
      >道
    </div>
  `,
  styleUrl: './atmosphere.component.scss',
})
export class AtmosphereComponent {}
